var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-side-nav"},_vm._l((_vm.routes),function(item){return _c('div',{key:item.uri,staticClass:"pl-nav-item",class:{ 'is-active': _vm.isActiveMenu(item) },on:{"click":function($event){return _vm.navigateTo(item.uri)}}},[_c('i',{class:_vm.getIcon(item)}),_c('span',{staticClass:"pl-nav-label"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }